export const environment = {
	enableDebug: false,
	production: true,
	localePath: './assets/locales/generated',
};
